import common from "../../assets/js/common";
import {Component , Vue } from 'vue-property-decorator'
import goodsInfo from "./components/goods-info/goods-info.vue" // 详情

@Component({
    components:{
        goodsInfo
    }
})
export default class goodsDetail extends Vue{
    listId= ''
    listDesc=''
    pageList={}
   
    created() {
        this.listId= this.$route.params.id
        this.getListAndTag();
        this.$store.dispatch('goods/getHotSaleListAsync')
    }
    get goodsDesc(){
        return this.$store.getters["collationData/getGoodsDetailData"]
    }
    get hotSaleList(){
        return this.$store.getters["goods/getHotSaleList"]
    }
    navClick(item:any,index:Number){
        if(index == 0){
            this.$router.push({path: '/list', query: {categoryOneIds:item.categoryId1}})
        } else {
            this.$router.push({path: '/list', query: {categoryOneIds:item.categoryId1,categoryTowIds:item.categoryId2}})
        }
    }
    getListAndTag() { //获取商品数据
        this.$store.dispatch('goods/getSpecificationAsync', {listId:this.listId,isGetFullInfo:true}).then((data:any)=>{
            this.similarGoods(data);
            this.$store.dispatch('collationData/changeGoodsDetailData',data)
        })
    }
    similarGoods(goods:any){
        this.fetch({//请求同类热销商品
          url: `${window.apis.getHotCommodityOfSameCategory}/${goods.cateInfo.categoryId1}/${goods.cateInfo.categoryId2}`,
          data: {}
        }).then((data:any)=>{
            this.pageList = common.arrSlice(data.list,3,false);
        })
    }
}